/**
 * TanStack Router: /performance/avaliacoes
 *
 * This route file was auto-generated by the route generation script.
 * Component: PerformanceAvaliacoesPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PerformanceAvaliacoesPage from '@/app/performance/avaliacoes/page'

/**
 * Route: /performance/avaliacoes
 * Layout: _auth (authenticated)
 * Component: PerformanceAvaliacoesPage
 */
export const Route = createFileRoute('/_auth/performance/avaliacoes/')({
  component: PerformanceAvaliacoesPage,
})
